import { useMemo } from 'react';
import filter from 'lodash/filter';
import get from 'lodash/get';

import { getGroupingColumnNames } from 'common/authoring_workflow/components/panes/DataPane/TableHierarchyGroupings/components/TableHierarchyGroupingHeader';
import { findHierarchyInfo } from 'common/visualizations/helpers/AgTableVifHelpers';
import { Vif } from 'common/visualizations/vif';

// Custom hook for getting all the necessary state / properties / information about column groupings inside Vif
const useColumnGroupings = (vif: Vif, advancedTotalingModalHierarchyId: string) => {
  const { hierarchies, hierarchyIndex } = findHierarchyInfo(vif, advancedTotalingModalHierarchyId);

  const columns = useMemo(() => get(vif, 'series[0].dataSource.dimension.columns', []), [vif]);
  const columnFormats = useMemo(() => get(vif, 'series[0].formatting.columnFormat', {}), [vif]);

  // All grouped columns
  const selectedColumnGroupings = useMemo(() => {
    const columnConfigs = filter(
      hierarchies[hierarchyIndex]?.columnConfigurations,
      (config) => config.isGrouping,
    );
    return columnConfigs;
  }, [hierarchies, hierarchyIndex]);

  // Names of all grouped columns
  const groupingColumnNames = useMemo(() => {
    return getGroupingColumnNames(selectedColumnGroupings, columns, columnFormats);
  }, [columns, selectedColumnGroupings, columnFormats]);

  // Column with advanced totaling config
  const columnWithAdvancedTotalingConfig = useMemo(() => {
    return selectedColumnGroupings.find(
      (selectedColumnGrouping) =>
        !!selectedColumnGrouping.subtotalLabel || !!selectedColumnGrouping.customFormula,
    );
  }, [selectedColumnGroupings]);

  return {
    columnWithAdvancedTotalingConfig,
    groupingColumnNames,
    hierarchyIndex,
    selectedColumnGroupings,
  };
};

export default useColumnGroupings;
